import React, { useState, useEffect } from 'react';
import { Table, DatePicker, TimePicker } from 'antd';
import { useSelector } from 'react-redux';
import '../../css/pdf.css';
import dayjs from "dayjs";
const Period = ({editedValues, setEditedValues }) => {
    const { statementDocument } = useSelector((state) => state.voyage);
    const { period } = statementDocument || {};

    // const formatDate = (date) => {
    //     const options = { day: '2-digit', month: 'short', year: 'numeric' };
    //     return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
    //   };

    // function formatTime(dateString) {
    //     const date = new Date(dateString);
    //     const hours = date.getHours().toString().padStart(2, '0');
    //     const minutes = date.getMinutes().toString().padStart(2, '0');
    //     return `${hours}:${minutes}`;
    // }
    const [editingField, setEditingField] = useState(null);

    
      const handleEdit = (field, value) => {
        setEditedValues((prev) => ({ ...prev, [field]: value }));
        // if (onUpdate) onUpdate(field, value);
      };

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date)) {
                throw new Error('Invalid date');
            }
            const options = { day: '2-digit', month: 'short', year: 'numeric' };
            return new Intl.DateTimeFormat('en-US', options).format(date);
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };
    
    const formatTime = (dateString) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date)) {
                throw new Error('Invalid date');
            }
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } catch (error) {
            console.error('Error formatting time:', error);
            return 'Invalid Time';
       
        }
    }    
    const customRowRender = () => {
        return (
            <>
                {/* <tr className="ant-table-row">
                    <td colSpan={4} className="period-custom-cell left-side-text">Sailing Period:</td>
                </tr> */}
                {/* Row 1 */}
        <tr className="ant-table-row">
          <td colSpan={1} className="period-custom-cell sb-background">
            Start Date & Time (UTC)
          </td>
          <td colSpan={1} className="period-custom-cell period-edit-cell">
            {editingField === "start_date" ? (
              <DatePicker
                value={editedValues.start_date ? dayjs(editedValues.start_date) : null}
                onChange={(date) => handleEdit("start_date", date)}
                onBlur={() => setEditingField(null)}
                autoFocus
              />
            ) : (
              <span onClick={() => setEditingField("start_date")}>
                {editedValues.start_date ? dayjs(editedValues.start_date).format("YYYY-MM-DD") : "N/A"}
              </span>
            )}
          </td>
          <td colSpan={1} className="period-custom-cell period-edit-cell period-time-edit-cell">
            {editingField === "start_time" ? (
              <TimePicker
                value={editedValues.start_date ? dayjs(editedValues.start_date) : null}
                onChange={(time) => handleEdit("start_date", time)}
                onBlur={() => setEditingField(null)}
                format="HH:mm"
                autoFocus
              />
            ) : (
              <span onClick={() => setEditingField("start_time")}>
                {editedValues.start_date ? dayjs(editedValues.start_date).format("HH:mm") : "N/A"}
              </span>
            )}
          </td>
        </tr>

        {/* Row 2 */}
        <tr className="ant-table-row">
          <td colSpan={1} className="period-custom-cell sb-background">
            End Date & Time (UTC)
          </td>
          <td colSpan={1} className="period-custom-cell period-edit-cell">
            {editingField === "end_date" ? (
              <DatePicker
                value={editedValues.end_date ? dayjs(editedValues.end_date) : null}
                onChange={(date) => handleEdit("end_date", date)}
                onBlur={() => setEditingField(null)}
                autoFocus
              />
            ) : (
              <span onClick={() => setEditingField("end_date")}>
                {editedValues.end_date ? dayjs(editedValues.end_date).format("YYYY-MM-DD") : "N/A"}
              </span>
            )}
          </td>
          <td colSpan={1} className="period-custom-cell period-edit-cell period-time-edit-cell">
            {editingField === "end_time" ? (
              <TimePicker
                value={editedValues.end_date ? dayjs(editedValues.end_date) : null}
                onChange={(time) => handleEdit("end_date", time)}
                onBlur={() => setEditingField(null)}
                format="HH:mm"
                autoFocus
              />
            ) : (
              <span onClick={() => setEditingField("end_time")}>
                {editedValues.end_date ? dayjs(editedValues.end_date).format("HH:mm") : "N/A"}
              </span>
            )}
          </td>
        </tr>
                {/* Row 3 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">From Port</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.from_port || 'N/A'}</td>
                </tr>
                {/* Row 4 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">To Port</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.to_port || 'N/A'}</td>
                </tr>
                {/* Row 5 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">Distance (NM)</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.total_distance?.toFixed(2) || 'N/A'}</td>
                </tr>
                {/* Row 6 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">Period</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.period || 'N/A'}</td>
                </tr>
                {/* Row 7 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">Total CO₂ Emitted (MT)</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.total_co2_emissions?.toFixed(2) || 'N/A'}</td>
                </tr>
                {/* Row 8 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">Compliance Balance (gCO₂eq)</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.compliance_balance?.toFixed(2) || 'N/A'}</td>
                </tr>
                {/* Row 9 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">CII</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.cii?.toFixed(2) || 'N/A'}</td>
                </tr>
                {/* Row 10 */}
                <tr className="ant-table-row">
                    <td colSpan={1} className="period-custom-cell sb-background">EEOI (gCO₂/Tonne-nm)</td>
                    <td colSpan={2} className="period-custom-cell" >{period?.eeoi?.toFixed(2) || 'N/A'}</td>
                </tr>
            </>
        );
    };

    return (
        <Table
            columns={[]} // Empty columns to hide default column structure
            dataSource={[{}]} // Empty data source to prevent default row rendering
            pagination={false}
            bordered
            showHeader={false}
            rowClassName={() => 'custom-row'}
            components={{
                body: {
                    wrapper: () => <tbody>{customRowRender()}</tbody>,
                },
            }}
        />
    );
}

export default Period;


//old Code Row 1 and 2:
//  <tr className="ant-table-row">
// <td colSpan={1} className="period-custom-cell sb-background">Start Date & Time (UTC)</td>
// <td colSpan={1} className="period-custom-cell" >{formatDate(period?.start_date) || 'N/A'}</td>
// <td colSpan={1} className="period-custom-cell" >{formatTime(period?.start_date) || 'N/A'}</td>
// </tr>
{/* Row 2 */}
{/* <tr className="ant-table-row">
<td colSpan={1} className="period-custom-cell sb-background">End Date & Time (UTC)</td>
<td colSpan={1} className="period-custom-cell" >{formatDate(period?.end_date) || 'N/A'}</td>
<td colSpan={1} className="period-custom-cell" >{formatTime(period?.end_date) || 'N/A'}</td>
</tr>  */}